// Settings → Reset tenant data (ADR-0058): what the page decides on its own.
// The API checks the owner, the switch, the phrase and the password again.

export const TENANT_RESET_PATH = '/setting-management/tenant-reset';

// How often the page asks whether the queued reset is done, and for how long.
export const POLL_INTERVAL_MS = 3000;
export const POLL_LIMIT_MS = 10 * 60 * 1000;

// Every table the reset reports, in the order it reports them; each has a label.
export const TENANT_RESET_TABLES = [
    'AuditDetail', 'Audit', 'Order', 'OrderItem', 'OrderContent', 'OrderDelivery', 'OrderImage',
    'Payment', 'Cart', 'DiscountUsage', 'Quote', 'QuoteItem', 'Invoice', 'InvoiceItem', 'InvoiceTransaction',
    'Signature', 'Stock', 'StockReservation', 'StockCasualty', 'Customer', 'CustomerEmailOptOut',
    'CalendarEvent', 'UserNotification', 'EmailNotification', 'UnsubscribeToken', 'Variant',
];

// The sidebar entry: the signed-in user's own flag from /auth/user.
export const isPlatformOwner = (user) => user?.isPlatformOwner === true;

// The same rule as TenantResetBusinessService.ConfirmationMatches: surrounding
// spaces and case do not matter, anything else does.
export const confirmationMatches = (phrase, typed) =>
    typeof typed === 'string' && typed.trim() !== '' &&
    String(phrase ?? '').trim().toUpperCase() === typed.trim().toUpperCase();

export const canSubmitReset = (preview, form, busy) =>
    Boolean(preview?.enabled) && !busy && (preview?.totalRows ?? 0) > 0 &&
    confirmationMatches(preview.confirmationPhrase, form?.confirmation) &&
    typeof form?.password === 'string' && form.password !== '';

export const tableLabelId = (name) =>
    TENANT_RESET_TABLES.includes(name) ? `TENANT_RESET.TABLE.${name}` : null;

// Only what the reset would actually touch; a fresh tenant lists nothing.
export const tablesToShow = (tables) =>
    (Array.isArray(tables) ? tables : []).filter(t => Number(t?.rows) > 0);

// The queued reset is done once a last reset at or after the request is read back.
export const resetFinished = (lastReset, requestedOn) => {
    const done = Date.parse(lastReset?.resetOn);
    const asked = Date.parse(requestedOn);
    return Number.isFinite(done) && Number.isFinite(asked) && done >= asked;
};

export const outcomeOf = (lastReset) => (lastReset?.error ? 'failed' : 'done');

export const requestOf = (form) => ({
    confirmation: form?.confirmation ?? '',
    password: form?.password ?? '',
    restartNumbering: form?.restartNumbering === true,
});
